import { render, staticRenderFns } from "./ObiButtonGroup.vue?vue&type=template&id=35a85017&scoped=true&"
import script from "./ObiButtonGroup.vue?vue&type=script&lang=js&"
export * from "./ObiButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./ObiButtonGroup.vue?vue&type=style&index=0&id=35a85017&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a85017",
  null
  
)

export default component.exports